import React, { useEffect, useState } from "react";
import { useLinksquaredService } from "../../Context/LinksquaredContext";
import {
  encodeMeetingURL,
  isValidMeetingData,
} from "../../Helpers/deepLinkHelper";

const DeepLinkComponent = () => {
  const { linksquaredReceivedData, setDeepLink } = useLinksquaredService(); // Get data from context

  useEffect(() => {
    // When linksquaredReceivedData is updated, check if it contains a deeplink
    if (linksquaredReceivedData) {
      if (isValidMeetingData(linksquaredReceivedData)) {
        const id = linksquaredReceivedData.meeting_id;
        const title = linksquaredReceivedData.meeting_title;
        const subtitle = linksquaredReceivedData.meeting_subtitle ?? "";

        let url = encodeMeetingURL(id, title, subtitle);
        setDeepLink(url);
      }
    }
  }, [linksquaredReceivedData]);

  return null; // No UI needed, just the confirmation dialog when the deep link is available
};

export default DeepLinkComponent;
